/* ==========================================================================
   OSERE — Aparición al entrar en pantalla, para todas las secciones

   Sustituye a CINCO copias casi idénticas del mismo script incrustadas en
   `os-composicion`, `os-protocolo`, `os-sodio`, `os-ciencia-teaser` y
   `os-fundadora` — unas 153 líneas de HTML que no se cacheaban entre páginas
   y que habían divergido en detalles que sí importan.

   🚨 LA DIVERGENCIA QUE ERA UN FALLO, y por eso este archivo existe.
   Cuatro de las cinco copias, con «reducir movimiento» activado, enseñaban el
   contenido de golpe —correcto—. La de `os-composicion` hacía esto:

       raiz.setAttribute('data-os-anim', 'true');   // el CSS esconde
       if (reducido) return;                        // sale sin revelar
       raiz.classList.add('os-anim');               // nunca llega

   Es decir: ponía el atributo que esconde y se iba. Con la preferencia del
   sistema activada, los cuatro pilares se quedaban en `opacity: 0` para
   siempre. Aquí el camino reducido enseña TODO y después sale.

   Regla que gobierna este archivo: el estado sin animación termina VISIBLE.
   Si algo falla —no hay soporte, el usuario pidió quietud— se ve el contenido.
   Nunca al revés.

   ⚠️ AQUÍ NO VA RED DE SEGURIDAD PARA EL OBSERVADOR: ya existe
   `os-reveal-safety.js`, que carga `theme.liquid` para todo el tema y revela
   lo que siga oculto pasado un margen. Escribir otra aquí era duplicar el
   mismo trabajo en dos sitios que luego divergen — que es justo el problema
   que este archivo viene a resolver.

   Uso, en la raíz de la sección:

     data-os-reveal-raiz                     obligatorio
     data-os-reveal-sel="[data-os-reveal]"   qué se revela  (por defecto, este)
     data-os-reveal-margen="0px 0px -8% 0px" rootMargin     (por defecto, este)
     data-os-reveal-umbral="0.1"             threshold      (por defecto, 0.1)
   ========================================================================== */

(function () {
  'use strict';

  var QUIETO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function montar(raiz) {
    if (raiz.hasAttribute('data-os-anim')) return; // ya montada

    var sel = raiz.getAttribute('data-os-reveal-sel') || '[data-os-reveal]';
    var piezas = raiz.querySelectorAll(sel);
    if (!piezas.length) return;

    function verTodo() {
      for (var i = 0; i < piezas.length; i++) piezas[i].classList.add('os-in');
    }

    /* El atributo y la clase van SIEMPRE, también en el camino reducido: el
       bloque de `prefers-reduced-motion` de las hojas apunta a
       `.os-anim [data-os-reveal].os-in`, así que sin la clase el contenido no
       se destapa ni añadiéndole `os-in`. */
    raiz.setAttribute('data-os-anim', 'true');
    raiz.classList.add('os-anim');

    if (QUIETO || !('IntersectionObserver' in window)) {
      verTodo();
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].isIntersecting) continue;
          entradas[i].target.classList.add('os-in');
          /* Se deja de observar al aparecer: si no, la pieza se re-anima cada
             vez que se vuelve a subir. */
          observador.unobserve(entradas[i].target);
        }
      },
      {
        rootMargin: raiz.getAttribute('data-os-reveal-margen') || '0px 0px -8% 0px',
        threshold: parseFloat(raiz.getAttribute('data-os-reveal-umbral')) || 0.1
      }
    );

    for (var j = 0; j < piezas.length; j++) observador.observe(piezas[j]);

  }

  function init(ambito) {
    var raices = (ambito || document).querySelectorAll('[data-os-reveal-raiz]');
    for (var i = 0; i < raices.length; i++) montar(raices[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  /* El personalizador reconstruye la sección al editarla. Sin esto, la clienta
     toca un ajuste y la sección se le queda invisible: con `data-os-anim`
     puesto por el marcado nuevo y nadie que añada `os-in`. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
